import * as React from "react";
import {
  List,
  DataTable,
  SearchInput,
  EditButton,
  ReferenceInput,
  ReferenceArrayInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  AutocompleteArrayInput,
  SelectInput,
  SelectArrayInput,
  FunctionField,
} from "react-admin";
import { SECTION_TYPES } from "../enums/SectionTypes";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";
import { validateRequired } from "../utils/Validations";
import { ENTITY_AVAILABILITY_STATUS } from "../enums/EntityAvailabilityStatus";
import {
  ENTITY_AVAILABILITY_STATUS_NAME,
  ENTITY_AVAILABILITY_STATUS_OPTIONS,
} from "../utils/EntityAvailabilityStatusUtils";

const SectionFilter = () => [
  <SearchInput source="title" alwaysOn />,
  <SelectArrayInput
    label="Estado"
    source="status"
    choices={ENTITY_AVAILABILITY_STATUS_OPTIONS}
    validate={validateRequired}
    alwaysOn
  />,
  <SelectInput
    label="Tipo"
    source="type"
    choices={[
      { id: SECTION_TYPES.PRODUCT, name: "Producto" },
      { id: SECTION_TYPES.RESTAURANT, name: "Restaurante" },
      { id: SECTION_TYPES.VIDEO, name: "Video" },
    ]}
  />,
  <ReferenceArrayInput
    source="restaurants"
    reference="restaurants"
    perPage={100}
    filter={{
      active: true,
      type: RESTAURANT_TYPES.ALL,
    }}
    label="Restaurante(s)"
  >
    <AutocompleteArrayInput
      filterToQuery={(searchText) => ({
        name: searchText,
        type: RESTAURANT_TYPES.ALL,
      })}
      label="Restaurante(s)"
      optionText="name"
    />
  </ReferenceArrayInput>,
  <ReferenceInput
    source="products"
    reference="products"
    perPage={100}
    filter={{
      status: [ENTITY_AVAILABILITY_STATUS.ACTIVE],
    }}
    label="Producto(s)"
  >
    <AutocompleteArrayInput
      filterToQuery={(searchText) => ({ name: searchText })}
      label="Producto(s)"
      optionText="name"
    />
  </ReferenceInput>,
];

const SectionList = () => (
  <List
    title="Secciones"
    filters={SectionFilter()}
    sort={{ field: "order", order: "ASC" }}
    exporter={false}
    filterDefaultValues={{
      status: [
        ENTITY_AVAILABILITY_STATUS.ACTIVE,
        ENTITY_AVAILABILITY_STATUS.INACTIVE,
      ],
    }}
  >
    <DataTable rowClick="show" bulkActionButtons={false}>
      <DataTable.Col source="title" label="Nombre" />
      <DataTable.Col source="products" label="Producto(s)">
        <ReferenceArrayField
          label="Producto(s)"
          reference="products"
          source="products"
        >
          <SingleFieldList linkType={false}>
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ReferenceArrayField>
      </DataTable.Col>
      <DataTable.Col source="restaurants" label="Restaurante(s)">
        <ReferenceArrayField
          label="Restaurante(s)"
          reference="restaurants"
          source="restaurants"
        >
          <SingleFieldList linkType={false}>
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ReferenceArrayField>
      </DataTable.Col>
      <DataTable.Col source="videos" label="Video(s)">
        <ReferenceArrayField
          label="Video(s)"
          reference="videos"
          source="videos"
        >
          <SingleFieldList linkType={false}>
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ReferenceArrayField>
      </DataTable.Col>
      <DataTable.NumberCol source="order" label="Orden" />
      <DataTable.Col source="status" label="Estado">
        <FunctionField
          source="status"
          label="Estado"
          render={(record) => ENTITY_AVAILABILITY_STATUS_NAME[record.status]}
        />
      </DataTable.Col>
      <DataTable.Col>
        <EditButton />
      </DataTable.Col>
    </DataTable>
  </List>
);

export default SectionList;
